const pathApiTransaction = `${process.env.REACT_APP_SERVICE_PATH_OSP}/api/trans`;

export const apiTransaction = {
  searchTrans: `${pathApiTransaction}/list`,
  exportTrans: `${pathApiTransaction}/export`,
  detailTrans: `${pathApiTransaction}/detail`,
};
